import { Link } from "wouter";
import { Facebook, Instagram, Linkedin } from "lucide-react";

interface FooterProps {
  // Früher unterschiedliche Hintergründe; seit dem Redesign überall derselbe helle Footer
  variant?: 'default' | 'homepage';
}

const columns: { title: string; links: { href: string; label: string }[] }[] = [
  {
    title: "Schnelllinks",
    links: [
      { href: "/", label: "Startseite" },
      { href: "/immobilien", label: "Immobilien" },
      { href: "/verkaufen", label: "Immobilie verkaufen" },
      { href: "/ueber-uns", label: "Über uns" },
      { href: "/blog", label: "Blog" },
      { href: "/kontakt", label: "Kontakt" },
    ],
  },
  {
    title: "Immobilien",
    links: [
      { href: "/immobilien?status=for-sale", label: "Kaufen" },
      { href: "/immobilien?status=for-rent", label: "Mieten" },
      { href: "/immobilien?type=new", label: "Neubau" },
      { href: "/immobilien?city=koeln", label: "Immobilien Köln" },
      { href: "/immobilien?city=roesrath", label: "Immobilien Rösrath" },
      { href: "/immobilien?city=moenchengladbach", label: "Immobilien Mönchengladbach" },
    ],
  },
  {
    title: "Rechtliches",
    links: [
      { href: "/impressum", label: "Impressum" },
      { href: "/datenschutz", label: "Datenschutz" },
      { href: "/agb", label: "AGB" },
      { href: "/widerrufsbelehrung", label: "Widerrufsbelehrung" },
      { href: "/cookie-richtlinie", label: "Cookie-Richtlinie" },
    ],
  },
];

const socials = [
  { href: "https://facebook.com", label: "Facebook", Icon: Facebook },
  { href: "https://instagram.com", label: "Instagram", Icon: Instagram },
  { href: "https://linkedin.com", label: "LinkedIn", Icon: Linkedin },
];

const Footer = (_props: FooterProps) => {
  return (
    <footer className="yh bg-yh-mist text-yh-muted">
      <div className="mx-auto max-w-[1280px] px-[var(--yh-gutter)] pb-10 pt-16 md:pt-20">
        <div className="grid grid-cols-2 gap-x-8 gap-y-12 md:grid-cols-4 lg:grid-cols-12">
          <div className="col-span-2 md:col-span-4 lg:col-span-6">
            <Link href="/" className="inline-block" aria-label="YADE HOME Startseite">
              <img src="/assets/YadeTransparent.png" alt="YADE HOME" className="h-10 w-auto brightness-0" />
            </Link>
            <p className="mt-6 max-w-sm text-[14px] leading-relaxed">
              YADE Home GmbH ist Projektentwickler und Immobilienmakler mit Sitz in Köln. Wir planen, bauen und
              verkaufen Wohnimmobilien und begleiten Käufer, Verkäufer und Investoren in ganz NRW.
            </p>
            <div className="mt-6 flex gap-2">
              {socials.map(({ href, label, Icon }) => (
                <a
                  key={label}
                  href={href}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={label}
                  className="flex h-9 w-9 items-center justify-center rounded-full text-yh-ink-2 transition-colors hover:bg-[#e8e8ed] hover:text-yh-ink"
                >
                  <Icon className="h-[18px] w-[18px]" strokeWidth={1.75} />
                </a>
              ))}
            </div>
          </div>

          {columns.map((col) => (
            <nav
              key={col.title}
              aria-label={col.title}
              className="lg:col-span-2"
            >
              <h3 className="text-[13px] font-semibold text-yh-ink">{col.title}</h3>
              <ul className="mt-4 space-y-3">
                {col.links.map((l) => (
                  <li key={l.href}>
                    <Link
                      href={l.href}
                      className="text-[13px] underline decoration-transparent underline-offset-4 transition-colors hover:text-yh-ink hover:decoration-current"
                    >
                      {l.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </nav>
          ))}
        </div>

        <div className="mt-14 flex flex-col gap-3 border-t border-yh-line pt-6 text-[12px] md:flex-row md:items-center md:justify-between">
          <p>&copy; {new Date().getFullYear()} YADE Home GmbH. Alle Rechte vorbehalten.</p>
          <p>Webdesign by InnQByte</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
